import { useOffersContext } from '@/app/components/hotel-detail/OffersProvider';

export default function useSelectedTransport() {
  const { offersData } = useOffersContext();
  return { data: offersData?.transport || null };
}
